// components
import CommonActionModal from "../Common/CommonActionModal";
import DeliveryControlledEntityCreateInner from "./DeliveryControlledEntityCreateInner";

// icons
import TableViewIcon from "@mui/icons-material/TableView";
import AddCircleIcon from "@mui/icons-material/AddCircle";


class DeliveryControlledEntityCreateModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            buttonVariant: 'soft',
            ready: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Добавление контролируемой сущности',
            modalIcon: TableViewIcon,
            mainComponent: DeliveryControlledEntityCreateInner,
            mainComponentProps: {
                delivery: this.props.delivery,
                callBack: this.setModalOpenFalse.bind(this),
            },
        }
    }

    async setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        );
        if (this.props.callBack){
            await this.props.callBack()
        }
    }
}

export default DeliveryControlledEntityCreateModal
